import { JobDescriptionRequest } from "./base/tsadv_JobDescriptionRequest";
import { FileDescriptor } from "./base/sys$FileDescriptor";
export class JobDescriptionRequestKzm extends JobDescriptionRequest {
  static NAME = "kzm_JobDescriptionRequestKzm";
  description?: string | null;
  ruFiles?: FileDescriptor[] | null;
  kzFiles?: FileDescriptor[] | null;
  enFiles?: FileDescriptor[] | null;
}
export type JobDescriptionRequestKzmViewName =
  | "_base"
  | "_local"
  | "_minimal"
  | "jobDescriptionRequest-edit";
export type JobDescriptionRequestKzmView<
  V extends JobDescriptionRequestKzmViewName
> = V extends "_base"
  ? Pick<
      JobDescriptionRequestKzm,
      | "id"
      | "description"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "requestNumber"
      | "requestDate"
      | "comment"
      | "basicInteractionsAtWork"
      | "positionDuties"
      | "generalAdditionalRequirements"
      | "compulsoryQualificationRequirements"
    >
  : V extends "_local"
  ? Pick<
      JobDescriptionRequestKzm,
      | "id"
      | "description"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "requestNumber"
      | "requestDate"
      | "comment"
      | "basicInteractionsAtWork"
      | "positionDuties"
      | "generalAdditionalRequirements"
      | "compulsoryQualificationRequirements"
    >
  : V extends "_minimal"
  ? Pick<JobDescriptionRequestKzm, "id" | "description">
  : V extends "jobDescriptionRequest-edit"
  ? Pick<
      JobDescriptionRequestKzm,
      | "id"
      | "basicInteractionsAtWork"
      | "positionDuties"
      | "generalAdditionalRequirements"
      | "compulsoryQualificationRequirements"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "requestNumber"
      | "requestDate"
      | "comment"
      | "positionGroup"
      | "file"
      | "status"
      | "description"
      | "ruFiles"
      | "kzFiles"
      | "enFiles"
      | "description"
    >
  : never;
